import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import {
  ReceiptsPage,
  areReceiptsSearchEqual,
  merchantReceiptsQueryOptions,
  normalizeReceiptsSearch,
  receiptsLoaderDeps,
  receiptsSearchSchema,
} from '@/features/receipts';
import { useAuthStore } from '@/stores/auth';

export const Route = createFileRoute('/_authed/receipts/')({
  validateSearch: zodValidator(receiptsSearchSchema),
  loaderDeps: ({ search }) => receiptsLoaderDeps(search),
  loader: ({ cause, context, deps }) => {
    const activeBranchId = useAuthStore.getState().activeBranchId;
    const branchId = activeBranchId && activeBranchId !== 'all' ? activeBranchId : undefined;

    if (cause === 'enter') {
      void context.queryClient.prefetchQuery(
        merchantReceiptsQueryOptions({
          ...deps,
          branch_id: branchId,
        }),
      );
    }
  },
  beforeLoad: ({ search }) => {
    const normalizedSearch = normalizeReceiptsSearch(search);

    if (!areReceiptsSearchEqual(search, normalizedSearch)) {
      throw redirect({
        to: '/receipts',
        search: normalizedSearch,
        replace: true,
      });
    }
  },
  component: ReceiptsIndexRouteComponent,
});

function ReceiptsIndexRouteComponent() {
  return <ReceiptsPage />;
}
